/* eslint-disable */
/**
 * Tabs component.
 * Tabs selection is triggered by clicks on the $trigger ('.js-tabs-item') element.
 *
 */

const $ = require('jquery');

const tabs = function() {
	const $tab = $('.js-tab'),
		$tabItem = $('.js-tab-item');

	// 0. Methods used in handlers
	const setItemActive = ($parent, selector) => {
		$('.js-tab-item', $parent).removeClass('is-active');
		$('.js-tab-item[data-target="' + selector + '"]').addClass('is-active');
	};
	const setContentActive = selector => {
		$(selector)
			.siblings()
			.removeClass('is-active');
		$(selector).addClass('is-active');
	};
	const updateHash = ($parent, hash) => {
		if ($parent.data('tab-hash') !== undefined) {
			window.location.hash = hash;
		}
	};

	// 1. Clicking on a tab item
	$tabItem.on('click', function() {
		// 1.1. Don't continue if the item is disabled (either on load or programmatically)
		if ($tabItem.attr('disabled') !== undefined) {
			return;
		}
		const tabId = $(this).data('target'),
			$parent = $(this).closest($tab);

		setItemActive($parent, tabId);

		setContentActive(tabId);

		updateHash($parent, tabId);
	});

	// 2. Clicking on a trigger that is not a tab item
	$('.js-tab-trigger').on('click', function() {
		const tabId = $(this).data('target'),
			$parent = $(this).closest($tab);

		setItemActive($parent, tabId);

		setContentActive(tabId);

		updateHash($parent, tabId);
	});

	// 3. If hash is programmatically changed, listen to hashchange (handles user going back/forward in the browser)
	if ($tab.data('tab-hash') !== undefined) {
		window.addEventListener('hashchange', function(e) {
			// If new hash doesn't match an active tab, switch to that tab
			if (
				$('.js-tab-item[data-target="' + window.location.hash + '"].is-active').length === 0
			) {
				// However if it doesn't exist at all, switch to first tab
				if ($('.js-tab-item[data-target="' + window.location.hash + '"]').length === 0) {
					const first = $('.js-tab-item').data('target');
					setItemActive($tab, first);
					setContentActive(first);
				} else {
					setItemActive($tab, window.location.hash);
					setContentActive(window.location.hash);
				}
			}
			// Scroll to top in case tab has less height
			window.scrollTo(0, 0);
		});
	}
};

module.exports = tabs;
